import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AskWrapper } from './components/AskWrapper';

async function LoadAskStep(): Promise<typeof AskWrapper> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ask" */ './components/AskWrapper'))
		.AskWrapper;
}

export function AskLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAskStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAskStep = LoadAskStep;
